import bossApi from '../../utils/fetch-api';

const DEFAULT_OPTIONS = { m2m: true, authScope: process.env.BOSS_API_AUTH_SCOPE_MAIL };
const HEADERS = {
  'Content-Type': 'application/json',
};

/**
 * Submit form data
 */
export const submit = async (formData: Record<string, string>, locale: string, recaptchaToken?: string) => {
  return await bossApi(`/mail/v2/mails`, {
    ...DEFAULT_OPTIONS,
    method: 'POST',
    headers: {
      ...HEADERS,
      ...(recaptchaToken ? { 'x-recaptcha-token': recaptchaToken } : {}),
    },
    body: formData,
    locale,
  });
};
